<template>
  <div class="timeCon">
    <ul class="tab">
      <li v-for="(item,index) in tab" :class="index==tabIndex?'on':''" @click="changeTab(index)">{{item}}</li>
    </ul>
    <div class="spraySetting" v-if="tabIndex==0">
      <p class="weekTitle">星期：</p>
      <p v-if="dayList.length>0&&dayList!='null'"><span v-for="(item,index) in dayList">{{item|filterWeek}}</span></p>
      <p class="noSetting" v-else>无</p>
      <p class="weekTitle">时间：</p>
      <p v-if="timeList.length>0&&timeList!='null'"><span v-for="(item,index) in timeList">{{item}}</span></p>
      <p class="noSetting" v-else>无</p>
    </div>
    <div class="drainSetting" v-if="tabIndex==1">
      <p class="weekTitle">星期：</p>
      <p v-if="dayList.length>0&&dayList!='null'"><span v-for="(item,index) in dayList">{{item|filterWeek}}</span></p>
      <p class="noSetting" v-else>无</p>
      <p class="weekTitle">时间：</p>
      <p v-if="timeList.length>0&&timeList!='null'"><span v-for="(item,index) in timeList">{{item}}</span></p>
      <p class="noSetting" v-else>无</p>
    </div>
    <!--       <table class="timeTable">
             <tr><th>工作开启时间</th><th>开启时长</th></tr>
             <tr v-for="(item,index) in timeList"><td>{{item.openTime}}</td><td>{{item.time|changeTime}}分钟</td></tr>
           </table> -->
  </div>
</template>

<script>
  export default {
    name:'timesetting',
    props:{
      device:{
        type:Object,
        required:true
      }
    },
    data(){
      return {
        tab:['喷药定时设置','排空定时设置'],
        dayList:[],
        timeList:[],
        tabIndex:0,
      }
    },
    mounted(){
      let device=this.device
      if(device.sparayWeeks){
        this.dayList=device.sparayWeeks.split(',')
      }
      if(device.sparayStartTime){
        this.timeList=device.sparayStartTime.split(',')
      }
    },
    methods:{
       changeTab(index){
         this.tabIndex=index
         let device=this.device
         if(index==0){
           if(device.sparayWeeks&&device.sparayWeeks!=null){
               this.dayList=device.sparayWeeks.split(',')
           }else{
             this.dayList=[]
           }
           if(device.sparayStartTime&&device.sparayStartTime!=null){
             this.timeList=device.sparayStartTime.split(',')
           }else{
             this.timeList=[]
           }
         }else{
            if(device.drainWeeks&&device.drainWeeks!=null){
              this.dayList=device.drainWeeks.split(',')
            }else{
              this.dayList=[]
            }
           if(device.drainStartTime&&device.drainStartTime!=null){
              this.timeList=device.drainStartTime.split(',')
           }else{
             this.timeList=[]
           }
         }
       },
    },
    filters:{
      filterWeek(val){
        let str=parseInt(val)
        switch (str){
          case 1:
          return '星期一'
          break;
          case 2:
          return '星期二'
          break;
          case 3:
          return '星期三'
          break;
          case 4:
          return '星期四'
          break;
          case 5:
          return '星期五'
          break;
          case 6:
          return '星期六'
          break;
          case 7:
          return '星期日'
          break;
        }
      }
    }
  }
</script>

<style scoped>
  .tab {height:40px;line-height: 40px;}
  .tab li {font-size:16px;width:100px;height:40px;margin-right:20px;float: left;cursor: pointer;}
  .tab li.on {color:#357AF1;border-bottom: #357AF1 2px solid;}
  .weekTitle {color:#999;margin-top:20px;margin-left:5px;}
  .spraySetting p span,.drainSetting p span  {color:#777;margin-right:15px;padding:5px 15px;border-radius:4px;background:#f4f4f4;}
  .noSetting {margin-left:5px;}
</style>



// WEBPACK FOOTER //
// src/components/TimeSettingChild.vue